import React, { useCallback, useState, useRef } from 'react';
import { BaseCell } from 'shared/grids/Cells';
import { Popup } from '@progress/kendo-react-popup';
import debounce from 'lodash/debounce';

const defaultAnchorAlign = { horizontal: 'right' };

const PopupCell = (props) => {
  const { children, popupContent, allowPopupHover = false, anchorAlign = defaultAnchorAlign, popupAlign, offset, ...cellProps } = props;

  const anchor = useRef(null);

  const [show, setShow] = useState(false);
  const debounced = useCallback(debounce(setShow, 300), []);

  const showPopup = () => debounced(true);
  const hidePopup = () => debounced(false);

  if (allowPopupHover) {
    return (
      <BaseCell {...cellProps} onMouseEnter={showPopup} onMouseLeave={hidePopup}>
        <div ref={anchor} className='popup-cell-content'>{children}</div>
        {show && <Popup anchor={anchor.current} show={show} anchorAlign={anchorAlign} popupAlign={popupAlign} offset={offset}>{popupContent}</Popup>}
      </BaseCell>
    );
  }

  return (
    <>
      <BaseCell {...cellProps} onMouseEnter={showPopup} onMouseLeave={hidePopup}>
        <div ref={anchor} className='popup-cell-content'>{children}</div>
      </BaseCell>
      {show && <Popup anchor={anchor.current} show={show} anchorAlign={anchorAlign} popupAlign={popupAlign} offset={offset}>{popupContent}</Popup>}
    </>
  );
};

export default PopupCell;
